module.exports = __webpack_public_path__ + "fonts/okticon.432df6c2318e100c9bf4b820be0c66e6.svg?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/font/okticon.svg
// module id = 718
// module chunks = 9